<template>
    <div>
        <div class="text-info">
            <div class="title">{{title}}</div>
            <div class="price">
                <div class="left">
                    <div>￥</div>
                    <div>现价</div>
                </div>
                <div class="right">
                    <template v-if="authType == 1">
                        {{priceInfo.price}}
                    </template>
                    <template v-if="authType == 2">
                        {{priceInfo.minPrice}}<span class="small-font">起</span>
                    </template>
                </div>
            </div>
            <div>
                <div class="origin-price">
                    <div class="left">
                        <div>￥</div>
                        <div>原价</div>
                    </div>
                    <div class="right">
                        <template v-if="authType == 1">
                            {{priceInfo.originalPrice}}
                        </template>
                        <template v-if="authType == 2">
                            {{priceInfo.minOriginalPrice}}<span class="small-font">起</span>
                        </template>
                    </div>
                </div>
                <div class="purchase-num" v-if="!isFree">
                    {{purchaseNum}}人已购
                </div>
            </div>
        </div>
        <div class="img-list">
            <img v-for="source in courselistImg" :key=source :src="source" alt="" />
        </div>
    </div>
</template>

<script>
    import jsonp from 'jsonp';
    export default {
        props: {
            title: {
                type: String
            },
            priceInfo: {
                type: Object,
                default: () => ({
                    price: 199,
                    originalPrice: 599
                })
            },
            purchaseNum: {
                type: Number
            },
            authType: {
                type: Number
            },
        },
        data() {
            return {
                courselistImg: [],
                isFree: false
            }
        },
        mounted(){
            if (+this.$route.query.free == 1) {
                this.isFree = true;
            }
            this.getImgList();
        },
        methods: {
            getImgList(v) {
                const url = process.env.VUE_APP_VERSION == 'prod' ? 'https://premiumapi.eastmoney.com/app' : 'http://premiumtest.eastmoney.com/appapi';
                jsonp(
                    url + "/api/TrialVersionAdvertising/Get?type=14",
                    { name: "cb", param: "cb" },
                    (err, data) => {
                        if (err) {
                            console.error(err.message);
                        } else {
                            var listlength = data.Data.length;
                            for (var i = 0; i < data.Data.length; i++) {
                                var strlist = data.Data[i].SkipUrl.split("_");
                                if (this.$route.query.courseId == strlist[0]) {
                                    this.courselistImg[strlist[1]] = data.Data[i].ImgUrl;
                                }
                            }
                            // console.log(this.courselistImg);
                        }
                    }
                );
            },
        }
    }
</script>

<style scoped>
.text-info {
    padding: 4px 16px;
    text-align: left;
}
.text-info div:last-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.title {
    font-size: 0.35rem;
    color: #333333;
    font-weight: 600;
}
.price, .origin-price {
    display: flex;
    align-items: center;
}
.price {
    color: #ff6600;
    line-height: 1;
}
.price .left {
    font-size: 0.3rem;
    margin-right: 4px;
}
.origin-price .left {
    font-size: 0.13rem;
    margin-right: 4px;
}
.left div {
    text-align: right;
}
.origin-price .left div:last-child {
    margin-right: 8px;
}
.price .right {
    font-size: 0.94rem;
    font-weight: 600;
}
.origin-price .right {
    font-size: 0.32rem;
    text-decoration: line-through;
}
.purchase-num {
    font-size: 0.3rem;
    color: #333333;
}
.small-font {
    font-size: 12px;
}
.origin-price .small-font {
    font-size: 0.13rem;
}
</style>